import { onMounted, onUnmounted, watch, type Ref } from 'vue'

export const useOnBeforeUnload = (msg: string, isListenerActiveRef?: Ref<boolean>) => {
  const handle = (event: BeforeUnloadEvent) => {
    event.preventDefault()
    event.returnValue = msg
    return msg
  }

  const addListener = () => {
    window.addEventListener('beforeunload', handle)
  }

  const removeListener = () => {
    window.removeEventListener('beforeunload', handle)
  }

  if (isListenerActiveRef) {
    watch(
      isListenerActiveRef,
      (active, _, onCleanup) => {
        if (active) {
          addListener()
          onCleanup(removeListener)
        }
      },
      { immediate: true },
    )
  } else {
    onMounted(addListener)
    onUnmounted(removeListener)
  }
}
